/* eslint-disable no-empty-pattern */
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { GROUPS, ADD_GROUP, SELECTED_GROUP, LOADING } from './mutations';
import api from '@/api';
import { getAccountMembers } from '@/store/modules/account/actions';
import { GROUP_TYPE } from '@/utils/groups-const';
const buildAccountActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getGroups = buildAccountActionObject('getGroups');
export const createGroup = buildAccountActionObject('createGroup');
export const updateGroup = buildAccountActionObject('updateGroup');
export const deleteGroup = buildAccountActionObject('deleteGroup');
export const setSelectedGroup = buildAccountActionObject('setSelectedGroup');
export const setGroupUsers = buildAccountActionObject('setGroupUsers');
export const addGroupUser = buildAccountActionObject('addGroupUser');
export const removeGroupUser = buildAccountActionObject('removeGroupUser');
export const syncGroup = buildAccountActionObject('syncGroup');
export const makeSyncedGroupManual = buildAccountActionObject('makeSyncedGroupManual');

let getGroupsPromise = null;

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getGroups.action]({ commit, state }) {
		if (!state.loading) {
			try {
				commit(LOADING, true);
				getGroupsPromise = api.getGroups();
				commit(GROUPS, await getGroupsPromise);
			} catch (err) {
				console.err(err);
				throw err;
			} finally {
				commit(LOADING, false);
			}
		}
		return getGroupsPromise;
	},
	async [createGroup.action]({ commit, state }, payload) {
		const ret = await api.createGroup(payload);
		if (payload.parent) {
			// is sub group
			const groups = [ret, ...state.groups];
			const selectedGroup = groups.find((x) => x.id === payload.parent);
			selectedGroup.sub_groups.push(ret.id);
			updateSelectedGroup(commit, groups, selectedGroup);
		} else {
			commit(ADD_GROUP, ret);
		}
		return ret;
	},
	async [updateGroup.action]({ commit, state, dispatch }, payload) {
		const groups = state.groups;
		const ret = await api.updateGroup(payload);
		commit(
			GROUPS,
			groups.map((x) => (x.id === ret.id ? ret : x))
		);
		if (state.selectedGroup?.id === ret.id) {
			commit(SELECTED_GROUP, ret);
		}
		if (ret.type === GROUP_TYPE.SYNCED) {
			await dispatch(getAccountMembers.fullPath, { forceGet: true }, { root: true });
		}
		return ret;
	},
	async [deleteGroup.action]({ dispatch }, payload) {
		const { id } = payload;
		const ret = await api.deleteGroup(id);
		// need to remove group and sub group from parent
		dispatch(getGroups.action);
		return ret;
	},
	async [setSelectedGroup.action]({ commit }, payload) {
		commit(SELECTED_GROUP, payload);
	},
	async [setGroupUsers.action]({ commit, state }, payload) {
		const { id, users } = payload;
		const groups = state.groups;
		const ret = await api.setGroupUsers(id, users);
		updateSelectedGroup(commit, groups, ret);
		return ret;
	},
	async [addGroupUser.action]({ commit, state }, payload) {
		const { id, user_id } = payload;
		const groups = state.groups;

		const ret = await api.addGroupUser(id, user_id);
		updateSelectedGroup(commit, groups, ret);
		return ret;
	},
	async [removeGroupUser.action]({ commit, state }, payload) {
		const { id, user_id } = payload;
		const groups = state.groups;

		const ret = await api.removeGroupUser(id, user_id);
		updateSelectedGroup(commit, groups, ret);
		return ret;
	},
	async [syncGroup.action]({ commit, dispatch }, payload) {
		const { id } = payload;
		const updatedGroup = await api.syncGroup(id);
		dispatch('credentials/setUserMatchingData', { credentialsId: updatedGroup?.synced?.credentials, force: true }, { root: true }); // called as string because of circular dep.
		const groups = await dispatch(getGroups.action); // we so not know what other groups are changed in this sync
		updateSelectedGroup(commit, groups, updatedGroup);
		return updatedGroup;
	},
	async [makeSyncedGroupManual.action]({ commit, state }, payload) {
		const { id } = payload;
		const groups = state.groups;
		const updatedGroup = await api.makeSyncedGroupManual(id);
		updateSelectedGroup(commit, groups, updatedGroup);
		return updateGroup;
	},
};

function updateSelectedGroup(commit, groups, group) {
	commit(
		GROUPS,
		groups.map((x) => (x.id === group.id ? group : x))
	);
	commit(SELECTED_GROUP, group);
}

export default actions;
